import { useEffect, useState } from "react";
import { NavLink, Outlet, useLocation, useNavigate } from "react-router-dom";
import {
  LayoutDashboard, Server, Wifi, Network, TrendingUp, ChevronsLeft, ChevronsRight,
  Receipt, Coins, Users, LogOut, Sun, Moon, LayoutGrid, X, Search, ScanSearch, Crown, Printer, FileBarChart, Wallet, Banknote, Headset, Package, HandCoins, Boxes, ShoppingCart, Unlink, DatabaseBackup, Settings, Terminal, Satellite, PhoneCall, Antenna, Cable, Building2, ScrollText, Calculator, ShieldCheck, History, ArrowLeftRight, LogIn, MessageSquareWarning, CalendarClock, ShieldAlert, CalendarCheck2, ClipboardList, ClipboardCheck, Landmark, HardHat,
} from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { useRouters } from "../context/RouterContext";
import { ChatNotifier } from "./ChatNotifier";
import { TaskReminderPopup } from "./tasks/TaskReminderPopup";
import { TeknisiNotifier } from "./TeknisiNotifier";
import { MaintenanceGate } from "./MaintenanceGate";
import { FloatingChat } from "./FloatingChat";
import PinConfirm from "./PinConfirm";
import { api } from "../lib/api";
import { SearchPicker } from "./SearchPicker";
import { Button } from "../components/ui/button";

export const SECTIONS = [
  {
    title: "UTAMA",
    items: [
      { to: "/", label: "Dashboard", icon: LayoutDashboard, end: true, hideMobileMenu: true },
      { to: "/komplain-wifi", label: "Chat Admin", icon: Headset, hideMobileMenu: true },
      { to: "/tugas-admin", label: "Tugas Admin", icon: ClipboardList, adminOnly: true },
      { to: "/laporan-teknisi", label: "Laporan Kerja Teknisi", icon: HardHat, adminOnly: true },
      { to: "/agen", label: "Agen & Komisi", icon: Users, hideMobileMenu: true },
      { to: "/isi-saldo", label: "Isi Saldo", icon: Banknote, agentOnly: true, hideMobileMenu: true },
      { to: "/mutasi-saya", label: "Mutasi Saldo", icon: ArrowLeftRight, agentOnly: true },
      { to: "/bulanan-starlink", label: "Bulanan Starlink", icon: Satellite, adminOnly: true },
      { to: "/starlink-fup", label: "Multi-Starlink FUP", icon: Satellite, adminOnly: true },
      { to: "/hutang-saldo", label: "Hutang Saldo", icon: HandCoins, agentOnly: true, needsDebt: true },
      { to: "/saldo", label: "Request Deposit", icon: Wallet, adminOnly: true },
      { to: "/history-deposit", label: "History Deposit", icon: History, adminOnly: true },
      { to: "/mutasi-saldo", label: "Mutasi Saldo", icon: ArrowLeftRight, adminOnly: true },
      { to: "/routers", label: "Daftar Cabang", icon: Server, adminOnly: true },
      { to: "/buka-cabang", label: "Pengajuan Cabang Baru", icon: Building2, adminOnly: true },
      { to: "/winbox", label: "Winbox", icon: Terminal, adminOnly: true },
      { to: "/backup-restore", label: "Backup & Restore", icon: DatabaseBackup, adminOnly: true },
    ],
  },
  {
    title: "VOUCHER & INTERNET",
    items: [
      { to: "/voucher-tuan-rumah", label: "Voucher Tuan Rumah", icon: Crown },
      { to: "/pelanggan-hp", label: "Pelanggan Banyak HP", icon: Users },
      { to: "/komplain-ppp", label: "Komplain Saya", icon: MessageSquareWarning, agentOnly: true },
      { to: "/reset-voucher", label: "Reset Voucher", icon: Unlink, agentOnly: true },
    ],
  },
  {
    title: "KEUANGAN & OMSET",
    items: [
      { to: "/laporan/omset", label: "Laporan Omset", icon: TrendingUp },
      { to: "/laporan/ppp", label: "Transaksi PPPoE", icon: Receipt },
      { to: "/ppp-jatuh-tempo", label: "PPPoE Jatuh Tempo", icon: CalendarClock },
      { to: "/laporan/wifi", label: "Lap. Omset Voucher", icon: Coins },
      { to: "/laporan/voucher-terpakai", label: "Voucher Terpakai", icon: LogIn },
      { to: "/laporan/alat", label: "Lap. Profit Alat", icon: Package, adminOnly: true },
      { to: "/laporan/voucher-wifi", label: "Transaksi Voucher", icon: Printer, adminOnly: true },
      { to: "/laporan/wifi-rumahan", label: "Transaksi PPPoE", icon: FileBarChart, adminOnly: true },
      { to: "/pembayaran-portal", label: "Pembayaran Portal", icon: Landmark, adminOnly: true },
      { to: "/laporan/evaluasi-ppp", label: "Evaluasi Perpanjangan PPPoE", icon: ClipboardCheck, adminOnly: true },
      { to: "/komplain-ppp", label: "Komplain PPPoE", icon: MessageSquareWarning, adminOnly: true },
      { to: "/laporan/reset-mencurigakan", label: "Reset Mencurigakan", icon: ShieldAlert, adminOnly: true },
      { to: "/laporan/setup-agen", label: "Laporan Setup Agen", icon: CalendarCheck2, adminOnly: true },
      { to: "/laporan/pendapatan-kotor", label: "Pendapatan Kotor", icon: Calculator, adminOnly: true },
      { to: "/laporan/penghasilan-agen", label: "Penghasilan Agen", icon: HandCoins, adminOnly: true },
    ],
  },
  {
    title: "ASET & STOK",
    items: [
      { to: "/aset", label: "Aset", icon: Boxes, rolesOnly: ["admin", "admin_fasnet", "teknisi_kepala"] },
      { to: "/lacak-aset", label: "Lacak Aset", icon: ScanSearch },
      { to: "/peta-odc-odp", label: "Peta ODC-ODP", icon: Cable },
      { to: "/stok", label: "Stok", icon: ShoppingCart, adminOnly: true },
      { to: "/pesan-alat", label: "Order Alat", icon: Package, adminOnly: true },
    ],
  },
  {
    title: "UPSTREAM PROVIDER",
    items: [
      { to: "/starlink", label: "Data Starlink", icon: Satellite, adminOnly: true },
      { to: "/telkom", label: "Data Telkom", icon: PhoneCall, adminOnly: true },
      { to: "/indosat", label: "Data Indosat", icon: Antenna, adminOnly: true },
      { to: "/moratel", label: "Data Moratel", icon: Cable, adminOnly: true },
      { to: "/indibiz", label: "Data Indibiz", icon: Building2, adminOnly: true },
    ],
  },
  {
    title: "PENGATURAN",
    items: [
      { to: "/users", label: "Manajemen User", icon: ShieldCheck, superOnly: true },
      { to: "/log-aktivitas", label: "Log Aktivitas", icon: ScrollText, adminOnly: true },
      { to: "/pengaturan", label: "Pengaturan", icon: Settings },
      { to: "/bhp-uso", label: "BHP USO Fasnet", icon: Landmark, superOnly: true },
    ],
  },
];

const BOTTOM_NAV = [
  { to: "/", label: "Beranda", icon: LayoutDashboard, end: true },
  { to: "/pesan-alat", label: "Order Alat", icon: Package },
  { to: "/vouchers", label: "Voucher", icon: Wifi, end: true },
  { to: "/ppp", label: "PPP", icon: Network },
];

export default function Layout() {
  const { user, logout, refreshUser } = useAuth();
  const location = useLocation();
  const { routers, selected, setSelected } = useRouters();
  const navigate = useNavigate();
  const isAdminUser = ["admin", "admin_fasnet"].includes(user?.role);
  const [dark, setDark] = useState(() => localStorage.getItem("fasnet_theme") === "dark");
  const [menuOpen, setMenuOpen] = useState(false);
  const [globalHidden, setGlobalHidden] = useState([]);

  // visibilitas menu global — diatur Super Admin dari halaman Pengaturan
  useEffect(() => {
    api.get("/config/hidden-menus").then((r) => setGlobalHidden(r.data.hidden || [])).catch(() => {});
  }, []);
  const hiddenSet = new Set([...(user?.hidden_menus || []), ...globalHidden]);

  useEffect(() => {
    document.documentElement.classList.toggle("dark", dark);
    localStorage.setItem("fasnet_theme", dark ? "dark" : "light");
    const onTheme = (e) => setDark(e.detail === "dark");
    window.addEventListener("fasnet-theme", onTheme);
    return () => window.removeEventListener("fasnet-theme", onTheme);
  }, [dark]);

  useEffect(() => {
    let alive = true;
    const poll = () => api.get("/chat/unread").then((r) => { if (alive) setChatUnread(Object.values(r.data || {}).reduce((a, b) => a + b, 0)); }).catch(() => {});
    poll();
    const t = setInterval(poll, 45000);
    return () => { alive = false; clearInterval(t); };
  }, []);

  const [openComplaints, setOpenComplaints] = useState(0);
  useEffect(() => {
    if (!isAdminUser) return undefined;
    let alive = true;
    const poll = () => api.get("/ppp/complaints/open-count").then((r) => { if (alive) setOpenComplaints(r.data.count || 0); }).catch(() => {});
    poll();
    const t = setInterval(poll, 30000);
    const onChange = () => poll();
    window.addEventListener("fasnet:complaints-changed", onChange);
    return () => { alive = false; clearInterval(t); window.removeEventListener("fasnet:complaints-changed", onChange); };
  }, [isAdminUser]);

  const [pinLogoutOpen, setPinLogoutOpen] = useState(false);
  const [hasDebt, setHasDebt] = useState(false);
  const [overdueAssets, setOverdueAssets] = useState(0);
  const [openTasks, setOpenTasks] = useState(0);
  const [resetReqs, setResetReqs] = useState(0);
  const [chatUnread, setChatUnread] = useState(0);

  useEffect(() => {
    if (isAdminUser) return undefined;
    api.get("/debts/active-count").then((r) => setHasDebt(r.data.count > 0)).catch(() => {});
    const t = setInterval(() => {
      api.get("/debts/active-count").then((r) => setHasDebt(r.data.count > 0)).catch(() => {});
    }, 60000);
    return () => clearInterval(t);
  }, [isAdminUser]);

  useEffect(() => {
    refreshUser();
    const t = setInterval(refreshUser, 60000);
    return () => clearInterval(t);
  }, [refreshUser]);

  useEffect(() => {
    if (!isAdminUser) return undefined;
    const fetchOverdue = () => api.get("/asset-units/summary").then((r) => setOverdueAssets(r.data.overdue.length)).catch(() => {});
    const fetchTasks = () => api.get("/admin-tasks/my-count").then((r) => setOpenTasks(r.data.count)).catch(() => {});
    const fetchResets = () => api.get("/reset-requests/count").then((r) => setResetReqs(r.data.count)).catch(() => {});
    fetchOverdue(); fetchTasks(); fetchResets();
    const t = setInterval(() => { fetchOverdue(); fetchTasks(); fetchResets(); }, 30000);
    return () => clearInterval(t);
  }, [isAdminUser]);

  const handleLogout = async () => {
    await logout();
    navigate("/login");
  };

  const routerSelect = (compact) => (
    <SearchPicker
      options={routers.map((r) => ({ value: r.id, label: `${r.name}${isAdminUser && r.host ? ` — ${r.host}` : ""}`, search: `${r.name} ${r.host || ""}` }))}
      value={selected} onChange={setSelected} placeholder="Pilih Router" searchPlaceholder="Cari router / cabang..." emptyText="Router tidak ditemukan" title="Pilih Router"
      testid={compact ? "select-router-mobile" : "select-router"}
      triggerClassName={compact ? "h-8 w-40 bg-white/15 border-white/25 text-white hover:bg-white/25 hover:text-white [&>svg]:text-white" : "w-56 h-9"} />
  );
  const [collapsed, setCollapsed] = useState(() => localStorage.getItem("sidebar_collapsed") === "1");
  const toggleCollapsed = () => setCollapsed((c) => { localStorage.setItem("sidebar_collapsed", c ? "0" : "1"); return !c; });
  const hasDot = (to) => (to === "/komplain-wifi" && chatUnread > 0) || (to === "/tugas-admin" && (openTasks + resetReqs) > 0) || (to === "/komplain-ppp" && openComplaints > 0) || (to === "/lacak-aset" && overdueAssets > 0) || (to === "/reset-voucher" && resetReqs > 0);
  const renderNav = (onNavigate, mini = false) => SECTIONS.map((sec) => (
    <div key={sec.title}>
      {mini ? <div className="mx-2 mb-2 border-t border-[#1A2644]" /> : <div className="px-3 mb-1.5 text-[10px] font-mono uppercase tracking-widest text-slate-500 font-semibold">{sec.title}</div>}
      <div className="space-y-0.5">
        {sec.items.filter((it) => (!it.adminOnly || isAdminUser) && (!it.rolesOnly || it.rolesOnly.includes(user?.role)) && (!it.superOnly || user?.role === "admin") && (!it.agentOnly || !isAdminUser) && (!it.needsDebt || hasDebt) && !hiddenSet.has(it.to)).map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.end}
            onClick={onNavigate}
            title={mini ? item.label : undefined}
            data-testid={`nav-${item.to === "/" ? "dashboard" : item.to.replace(/\//g, "-").slice(1)}`}
            className={({ isActive }) =>
              `relative flex items-center gap-3 ${mini ? "justify-center px-0 py-2.5" : "px-3 py-2.5"} rounded-xl text-sm transition-colors duration-200 ${
                isActive
                  ? "bg-[#F04E23] text-white border border-[#F04E23]/40 font-semibold shadow-lg shadow-[#F04E23]/25"
                  : "text-slate-400 hover:text-white hover:bg-white/5 border border-transparent"
              }`
            }
          >
            <item.icon className={`${mini ? "w-5 h-5" : "w-4 h-4"} shrink-0`} />
            {mini ? (hasDot(item.to) && <span className="absolute top-1 right-2 w-2 h-2 rounded-full bg-rose-500 animate-pulse" data-testid={`nav-dot-${item.to.replace(/\//g, "-").slice(1)}`} />) : <>
            {item.label}
            {item.to === "/komplain-wifi" && chatUnread > 0 && (
              <span className="ml-auto min-w-5 h-5 px-1 rounded-full bg-rose-500 text-white text-[10px] font-bold font-mono flex items-center justify-center animate-pulse" data-testid="nav-chat-badge">{chatUnread}</span>
            )}
            {item.to === "/tugas-admin" && (openTasks + resetReqs) > 0 && (
              <span className="ml-auto min-w-5 h-5 px-1 rounded-full bg-amber-500 text-black text-[10px] font-bold font-mono flex items-center justify-center" title={resetReqs ? `${resetReqs} pengajuan reset voucher menunggu` : ""} data-testid="nav-tasks-badge">{openTasks + resetReqs}</span>
            )}
            {item.to === "/reset-voucher" && resetReqs > 0 && (
              <span className="ml-auto min-w-5 h-5 px-1 rounded-full bg-amber-500 text-black text-[10px] font-bold font-mono flex items-center justify-center animate-pulse" title="Pengajuan reset voucher menunggu persetujuan" data-testid="nav-reset-badge">{resetReqs}</span>
            )}
            {item.to === "/lacak-aset" && overdueAssets > 0 && (
              <span className="ml-auto min-w-5 h-5 px-1 rounded-full bg-rose-500 text-white text-[10px] font-bold font-mono flex items-center justify-center animate-pulse" data-testid="nav-lacak-aset-badge">{overdueAssets}</span>
            )}
            {item.to === "/komplain-ppp" && openComplaints > 0 && (
              <span className="ml-auto min-w-5 h-5 px-1 rounded-full bg-rose-500 text-white text-[10px] font-bold font-mono flex items-center justify-center animate-pulse" data-testid="nav-komplain-ppp-badge">{openComplaints}</span>
            )}
            </>}
          </NavLink>
        ))}
      </div>
    </div>
  ));

  return (
    <div className="min-h-screen bg-background" data-testid="app-layout">
      {/* Sidebar desktop */}
      <aside className={`hidden lg:flex ${collapsed ? "w-16" : "w-64"} shrink-0 border-r border-[#1A2644] bg-[#050914] text-slate-300 fixed inset-y-0 z-30 flex-col shadow-xl transition-[width] duration-200`} data-testid="sidebar-desktop" data-collapsed={collapsed ? "1" : "0"}>
        <div className={`flex items-center ${collapsed ? "justify-center px-0" : "gap-3 px-5"} h-20 border-b border-[#1A2644] bg-[#040810]/60`}>
          {collapsed ? (
            <button type="button" onClick={toggleCollapsed} className="rounded-lg p-2 border border-white/10 hover:bg-white/5" style={{ background: "#040810" }} title="Perlebar menu" data-testid="sidebar-expand">
              <img src="/logo.png?v=2" alt="Fasnet" className="h-6 w-auto max-w-[36px] object-cover object-left" data-testid="logo-sidebar-mini" />
            </button>
          ) : (
            <div className="rounded-xl px-3 py-2 border border-white/10" style={{ background: "#040810" }}>
              <img src="/logo.png?v=2" alt="Fasnet Fiber" className="h-10 w-auto object-contain" data-testid="logo-sidebar" />
            </div>
          )}
        </div>
        <nav className={`flex-1 overflow-y-auto py-4 ${collapsed ? "px-2 space-y-2" : "px-3 space-y-5"}`} data-testid="sidebar-nav">
          {renderNav(undefined, collapsed)}
        </nav>
        <button type="button" onClick={toggleCollapsed} className="h-11 shrink-0 border-t border-[#1A2644] flex items-center justify-center gap-2 text-xs text-slate-400 hover:text-white hover:bg-white/5 transition-colors" title={collapsed ? "Perlebar menu" : "Kecilkan menu (ikon saja)"} data-testid="sidebar-toggle">
          {collapsed ? <ChevronsRight className="w-4 h-4" /> : <><ChevronsLeft className="w-4 h-4" /> Kecilkan menu</>}
        </button>
      </aside>

      {/* App bar mobile (Dark Navy FASNET) */}
      <div className="lg:hidden fixed top-0 inset-x-0 z-30 bg-[#050914] text-white border-b border-[#1A2644] shadow-md shadow-black/30">
        <div className="flex items-center gap-2.5 px-4 h-14">
          <div className="rounded-lg px-2 py-1 shadow-sm border border-white/10" style={{ background: "#040810" }}>
            <img src="/logo.png?v=2" alt="Fasnet Fiber" className="h-8 w-auto object-contain" data-testid="logo-mobile" />
          </div>
          <div className="flex-1" />
          <div data-testid="router-selector-mobile">{routerSelect(true)}</div>
        </div>
      </div>

      <div className={`${collapsed ? "lg:ml-16" : "lg:ml-64"} flex flex-col min-h-screen transition-[margin] duration-200`}>
        {/* Header desktop */}
        <header className="hidden lg:flex h-16 border-b border-border bg-card/80 backdrop-blur-xl sticky top-0 z-20 items-center gap-3 px-6">
          <div className="flex items-center gap-2" data-testid="router-selector">
            <Server className="w-4 h-4 text-muted-foreground" />
            {routerSelect(false)}
          </div>
          <div className="flex-1" />
          <Button variant="ghost" size="icon" onClick={() => setDark(!dark)} data-testid="btn-theme-toggle">
            {dark ? <Sun className="w-4 h-4" /> : <Moon className="w-4 h-4" />}
          </Button>
          <div className="text-right hidden sm:block">
            <div className="text-xs text-muted-foreground font-mono" data-testid="header-admin-meta">{["admin", "admin_fasnet"].includes(user?.role) ? (user?.role === "admin_fasnet" ? "Admin Fasnet" : "Super Admin") : user?.agent_type || "Mitra"}</div>
          </div>
          <Button variant="outline" size="sm" onClick={() => setPinLogoutOpen(true)} data-testid="btn-logout">
            <LogOut className="w-4 h-4 mr-1.5" /> Keluar
          </Button>
        </header>
        <main className="flex-1 p-4 pt-[72px] pb-24 lg:p-8">
          <MaintenanceGate><Outlet /></MaintenanceGate>
          <ChatNotifier />
          {isAdminUser && <TaskReminderPopup />}
          <TeknisiNotifier />
          <FloatingChat />
        </main>
        {location.pathname === "/" && (
          <footer className="px-4 pb-24 lg:pb-6 lg:px-8 text-center" data-testid="app-footer">
          <div className="inline-block rounded-2xl border border-border bg-card/60 px-6 py-4 shadow-sm" data-testid="footer-legalitas">
            <div className="text-[10px] font-mono uppercase tracking-[0.2em] text-[#F04E23] font-bold mb-1.5">Legalitas Resmi</div>
            <div className="text-xs leading-relaxed text-foreground/80 font-mono font-semibold space-y-0.5">
              <div><span className="text-muted-foreground">Badan Usaha:</span> <span className="font-bold text-foreground text-sm">PT. Fasnet Sky Fiber</span></div>
              <div><span className="text-muted-foreground">SKLO Kemkomdigi:</span> 372/TEL.04.02/2024</div>
              <div><span className="text-muted-foreground">AS Number:</span> AS152793</div>
              <div><span className="text-muted-foreground">NIB:</span> 0105240016275</div>
              <div><span className="text-muted-foreground">NPWP:</span> 20.021.354.4-704.000</div>
            </div>
          </div>
        </footer>
        )}
      </div>

      {/* Bottom navigation mobile (gaya PPOB) */}
      <nav className="lg:hidden fixed bottom-0 inset-x-0 z-30 bg-card/95 backdrop-blur-xl border-t border-border shadow-[0_-4px_24px_rgba(5,9,20,0.12)]" data-testid="bottom-nav">
        <div className="grid grid-cols-5">
          {BOTTOM_NAV.filter((item) => !hiddenSet.has(item.to)).map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              data-testid={`bnav-${item.to === "/" ? "dashboard" : item.to.replace(/\//g, "-").slice(1)}`}
              className={({ isActive }) =>
                `flex flex-col items-center gap-1 py-2 text-[10px] font-medium transition-colors ${
                  isActive ? "text-primary" : "text-muted-foreground"
                }`
              }
            >
              {({ isActive }) => (
                <>
                  <div className={`w-10 h-7 rounded-full flex items-center justify-center transition-colors ${isActive ? "bg-primary/10" : ""}`}>
                    <item.icon className="w-5 h-5" />
                  </div>
                  {item.label}
                </>
              )}
            </NavLink>
          ))}
          <button
            onClick={() => setMenuOpen(true)}
            className="flex flex-col items-center gap-1 py-2 text-[10px] font-medium text-muted-foreground"
            data-testid="bnav-menu"
          >
            <div className="w-10 h-7 rounded-full flex items-center justify-center">
              <LayoutGrid className="w-5 h-5" />
            </div>
            Menu
          </button>
        </div>
      </nav>

      {/* Sheet semua menu (mobile) */}
      {menuOpen && (
        <div className="lg:hidden fixed inset-0 z-50" data-testid="mobile-menu-sheet">
          <div className="absolute inset-0 bg-black/40" onClick={() => setMenuOpen(false)} />
          <div className="absolute bottom-0 inset-x-0 bg-card rounded-t-3xl p-5 pb-8 max-h-[80vh] overflow-y-auto shadow-2xl">
            <div className="flex items-center justify-between mb-4">
              <div className="font-heading font-bold">Semua Menu</div>
              <div className="flex gap-1">
                <Button variant="ghost" size="sm" onClick={() => setDark(!dark)} data-testid="btn-theme-toggle-mobile">
                  {dark ? <Sun className="w-4 h-4" /> : <Moon className="w-4 h-4" />}
                  <span className="text-xs font-medium ml-1">Mode {dark ? "Terang" : "Gelap"}</span>
                </Button>
                <Button variant="ghost" size="icon" onClick={() => setMenuOpen(false)} data-testid="btn-close-menu">
                  <X className="w-5 h-5" />
                </Button>
              </div>
            </div>
            <div className="grid grid-cols-3 gap-2 mb-5">
              {SECTIONS.flatMap((s) => s.items).filter((it) => !it.hideMobileMenu && (!it.adminOnly || isAdminUser) && (!it.superOnly || user?.role === "admin") && (!it.agentOnly || !isAdminUser) && !hiddenSet.has(it.to)).map((item) => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  end={item.end}
                  onClick={() => setMenuOpen(false)}
                  data-testid={`mnav-${item.to === "/" ? "dashboard" : item.to.replace(/\//g, "-").slice(1)}`}
                  className="flex flex-col items-center gap-1.5 p-3 rounded-2xl bg-accent/50 hover:bg-accent text-center"
                >
                  <div className="relative">
                    <item.icon className="w-5 h-5 text-primary" />
                    {item.to === "/lacak-aset" && overdueAssets > 0 && (
                      <span className="absolute -top-1.5 -right-2 min-w-4 h-4 px-1 rounded-full bg-rose-500 text-white text-[9px] font-bold font-mono flex items-center justify-center" data-testid="mnav-lacak-aset-badge">{overdueAssets}</span>
                    )}
                  </div>
                  <span className="text-[11px] font-medium leading-tight">{item.label}</span>
                </NavLink>
              ))}
            </div>
            <div className="flex items-center justify-between px-1">
              <div>
                <div className="text-sm font-medium">{user?.name || "Admin"}</div>
              </div>
              <Button variant="destructive" size="sm" onClick={() => { setMenuOpen(false); setPinLogoutOpen(true); }} data-testid="btn-logout-mobile">
                <LogOut className="w-4 h-4 mr-1.5" /> Keluar
              </Button>
            </div>
          </div>
        </div>
      )}
      <PinConfirm
        open={pinLogoutOpen}
        onOpenChange={setPinLogoutOpen}
        title="Keluar dari Akun?"
        description="Masukkan PIN Anda untuk konfirmasi keluar dari sistem."
        confirmLabel="Ya, Keluar"
        destructive
        onConfirm={handleLogout}
        testid="pin-logout"
      />
    </div>
  );
}
